import { Component, inject, Input, model } from '@angular/core';
import { IMyOskSubscriptonsVm } from '../../../../api/my-osk-subscriptons-vm.model';
import { MyOskSubscriptionsService } from '../../../../api/api-services/my-osk-subscriptions.service';
import { Observable, tap } from 'rxjs';

@Component({
  selector: 'app-subscription-selector',
  templateUrl: './subscription-selector.component.html',
  styleUrl: './subscription-selector.component.scss'
})
export class SubscriptionSelectorComponent {
  private _myOskSubscriptionsService = inject(MyOskSubscriptionsService);

  missingSubscriptionMessage = model<string | null>(null);
  selectedSubscription = model<IMyOskSubscriptonsVm[]>([]);

  availableSubscriptionsList: IMyOskSubscriptonsVm[] = [];

  public oskSubscriptionPlans: Observable<IMyOskSubscriptonsVm[]> = this._myOskSubscriptionsService.get().pipe(
    tap((res: IMyOskSubscriptonsVm[]) => {
      this.availableSubscriptionsList = res;
    })
  );

  
  selectAvailableSubscription(subscription: IMyOskSubscriptonsVm): void {
    this.missingSubscriptionMessage.set(null) ; // Reset the missing subscription message

    const selectedSub = this.selectedSubscription()[0];

    if (selectedSub && selectedSub.planGuid === subscription.planGuid) {
      return; // Prevent re-selecting the same subscription
    }

    // Restore the available count of the previously selected subscription
    if (selectedSub) {
      const prevSubIndex = this.availableSubscriptionsList.findIndex(
        (item) => item.planGuid === selectedSub.planGuid
      );
      if (prevSubIndex !== -1) {
        this.availableSubscriptionsList[prevSubIndex].availablePlans += 1;
      }
    }

    // Update selected subscription
    this.selectedSubscription.set([subscription])

    // Reduce the available count of the newly selected subscription
    const newSubIndex = this.availableSubscriptionsList.findIndex(
      (item) => item.planGuid === subscription.planGuid
    );
    if (newSubIndex !== -1) {
      this.availableSubscriptionsList[newSubIndex].availablePlans -= 1;
    }
  }

  removeSelectedSubscription(guid: string): void {
    const index = this.availableSubscriptionsList.findIndex(
      (item) => item.planGuid === guid
    );

    if (index !== -1) {
      this.availableSubscriptionsList[index].availablePlans += 1;
    }

    this.selectedSubscription.set([]);
  }
}
